import { memo } from 'react'
import isEqual from 'react-fast-compare'
import { useRefinementList } from 'react-instantsearch'

const ColorRefinementListComponent = ({
  attribute,
  limit,
  showMoreLimit,
  showMore,
}: {
  attribute: string
  limit: number
  showMoreLimit: number
  showMore: boolean
}) => {
  const { items, isShowingMore, refine, toggleShowMore } = useRefinementList({
    attribute,
    limit,
    showMoreLimit,
    showMore,
  })

  if (items.length < 1)
    return (
      <div className="flex flex-col gap-4 flex-wrap pl-4 mb-9">
        <span>No items to filter</span>
      </div>
    )

  return (
    <ul className="flex flex-col gap-4 flex-wrap pl-4 mb-9">
      {items.map(({ label, value, isRefined, count }, idx) => {
        const backgroundColor = label.split('|')[1]
        const nameColor = label.split('|')[0]

        return (
          <li key={`filter-color-${idx}-${label}`}>
            <button type="button" onClick={() => refine(value)} className="capitalize flex flex-row gap-2 w-full">
              {/* Hex color */}
              <span
                className={`${
                  isRefined ? 'ring-1 ring-secondary ring-offset-2' : ''
                } border border-outlined-medium flex rounded-full m-0.5 w-6 h-6`}
                style={{ backgroundColor }}
              />
              <span>{`${nameColor} (${count})`}</span>
            </button>
          </li>
        )
      })}
      {showMore && limit <= items.length && (
        <button className="text-left hover:underline" onClick={() => toggleShowMore()}>
          {!isShowingMore ? 'Show more' : 'Show less'}
        </button>
      )}
    </ul>
  )
}

export const ColorRefinementList = memo(ColorRefinementListComponent, isEqual)
